import { connect } from '@atlassian/jira-react-redux/src/index.tsx';
import { cancel, deleteVersion } from '../../state/actions.tsx';
import { isSwapValid, isInProgress } from '../../state/selectors.tsx';
import type { State } from '../../state/types.tsx';
import Footer from './view.tsx';

const mapStateToProps = (state: State) => ({
	isDeleteEnabled: isSwapValid(state),
	isDeleteInProgress: isInProgress(state),
});

const mapDispatchToProps = {
	onCancel: cancel,
	onDelete: deleteVersion,
} as const;

export default connect(mapStateToProps, mapDispatchToProps)(Footer);
